import { PlainHoverEffect } from "styles/hoverPresets";
import CardsList from "@/components/cardsList";
import { IMPLEMENTATION_CONSTANTS } from "./constants";

const Implementation = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2 }}
      desc={IMPLEMENTATION_CONSTANTS.desc}
      title={IMPLEMENTATION_CONSTANTS.title}
      list={IMPLEMENTATION_CONSTANTS.list}
      spacing={{ base: 8 }}
      hoverEffect
      hover={PlainHoverEffect}
    />
  );
};

export default Implementation;
